function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { InputNumber, Input } from 'mkui-fd';
import Popedit from '../popedit';
import React from 'react';
import CurrencyPanel from './CurrencyPanel';
import { getPopeditValue, getNumberValue } from './util';
var InputGroup = Input.Group;

var EnhancedCurrency = function EnhancedCurrency(props) {
  var dataSources = props.dataSources,
      value = props.value,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, ["dataSources", "value", "onChange"]);

  var changePopeditValueHandle = function changePopeditValueHandle(key) {
    onChange({
      currency: key,
      value: value.value
    });
  };

  var changeNumberHandle = function changeNumberHandle(newValue) {
    onChange({
      currency: value.currency,
      value: newValue
    });
  };

  return React.createElement(InputGroup, {
    compact: true
  }, React.createElement(Popedit, _extends({}, rest, {
    allowClear: false,
    lazyLoad: false,
    value: getPopeditValue(dataSources, value.currency),
    onChange: changePopeditValueHandle,
    inputClassName: "currency-select-input"
  }), React.createElement(CurrencyPanel, {
    dataSources: dataSources
  })), React.createElement(InputNumber, _extends({}, rest, {
    value: value.value,
    onChange: changeNumberHandle
  })));
};

export default EnhancedCurrency;
//# sourceMappingURL=EnhancedCurrency.js.map
